module.exports = __webpack_public_path__ + "static/sanfranciscodisplay-medium-webfont-81f0b3d5cf86c72391ff1bd061a41977.woff";